export enum initTypes {
  FETCH_INIT_REQUEST = "FETCH_INIT_REQUEST",
  FETCH_INIT_SUCCESS = "FETCH_INIT_SUCCESS",
  FETCH_INIT_FAILURE = "FETCH_INIT_FAILURE",
}